var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineUserProfileFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 62,
    viewBox: "0 0 52 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9987 29.2269C28.5483 29.2269 30.9935 28.214 32.7964 26.4111C34.5993 24.6083 35.6121 22.1631 35.6121 19.6134C35.6121 17.0638 34.5993 14.6186 32.7964 12.8157C30.9935 11.0128 28.5483 10 25.9987 10C23.449 10 21.0038 11.0128 19.201 12.8157C17.3981 14.6186 16.3853 17.0638 16.3853 19.6134C16.3853 22.1631 17.3981 24.6083 19.201 26.4111C21.0038 28.214 23.449 29.2269 25.9987 29.2269ZM44.2786 50.8571C43.0362 46.9853 40.5966 43.608 37.3113 41.212C34.0261 38.8159 30.0649 37.5249 25.9987 37.5249C21.9325 37.5249 17.9713 38.8159 14.686 41.212C11.4008 43.608 8.96115 46.9853 7.71875 50.8571H44.2786Z",
    stroke: "white",
    strokeWidth: 4.80671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineUserProfileFocus);
export default __webpack_public_path__ + "static/media/streamline_user-profile-focus.28e166a91209c7f035966f261d5b7525.svg";
export { ForwardRef as ReactComponent };